import React from 'react'

class FormInputTextDisabled extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className='inputContainer disabled filled'>
        <input type="text" name={this.props.name} readOnly value={this.props.value} />
        <label>{this.props.label}</label>
        <div className="icon">
          <img src="./img/lock.png" />
        </div>
      </div>
    );
  }
}

export default FormInputTextDisabled;


// WEBPACK FOOTER //
// ./src/components/shared/disabled_input.js